export default "__VITE_ASSET__JPc70O4g__"